var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Grid',{attrs:{"col":"12"}},[_vm._t("title"),_c('div',{staticClass:"fields"},[_vm._t("fields")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }